export default __webpack_public_path__ + "static/media/3.a228f646.svg";